// extracted by mini-css-extract-plugin
export default {"info":"info_info__OIAk4","label":"info_label__QHB7i","value":"info_value__npWDg"};